export const EXTERNAL_USER_SET = "EXTERNAL_USER_SET";
export const EXTERNAL_USER_SET_FROM_ID = "EXTERNAL_USER_SET_FROM_ID";
export const EXTERNAL_USER_UNSET = "EXTERNAL_USER_UNSET";
export const USER_FRIEND_REQUEST = "USER_FRIEND_REQUEST";
export const EXTERNAL_USER_SET_REQUESTING = "EXTERNAL_USER_SET_REQUESTING";
